import React, { useState } from 'react'
import { Navigation } from './navigation'
import { AppHeader } from './app-header'
import { AppFooter } from './app-footer'

import { Layout } from 'antd'

const { Content } = Layout

export const AuthenticatedLayout: React.FC = ({ children }) => {
  const [collapse, setCollapsed] = useState(true)
  return (
    <Layout>
      <Navigation collapsed={collapse} handleToggleMenu={() => setCollapsed(!collapse)} />
      <Layout>
        <AppHeader collapsed={collapse} handleToggleMenu={() => setCollapsed(!collapse)} />
        <Content style={{ padding: '8px' }}>{children}</Content>
        <AppFooter />
      </Layout>
    </Layout>
  )
}
